export default {
  path: "/SectionContent/ContributingFactors",
  name: "Contributing Factors",
  htmlContent: "contributing_factors.html",
  headings: [
    {
      id: "n49SuspectedOperatorPedContributingFactors",
      text: "49. Suspected Operator / Ped Contributing Factors",
      type: "field",
    },
    {
      id: "n50VehicleContributingFactors",
      text: "50. Vehicle Contributing Factors",
      type: "field",
    },
    {
      id: "n51RoadwayContributingFactors",
      text: "51. Roadway Contributing Factors",
      type: "field",
    },
  ],
};
